// API configuration utility

const API_URL = import.meta.env.VITE_API_URL || 'https://dev.maker4u.com';
const ENV = import.meta.env.VITE_ENV || 'dev';

console.log('env', import.meta.env.VITE_ENV, import.meta.env.VITE_API_URL );

// API endpoints
const ENDPOINTS = {
  // Auth endpoints
  GET_SUBSCRIPTION_DATA: '/aapi/getsubscriptiondata.php',
  SAVE_USER_TEMPLATE: '/aapi/saveusertemplete.php',
  GET_USER_TEMPLATES: '/aapi/getUsertempletes.php',
  GET_USER_TEMPLATE_SUBSCRIPTION: '/aapi/getusertemp_subs.php',
  GET_USER_TEMPLATE_BY_ID: '/aapi/getusertemp_byid.php',
  GET_TEMPLATE_BY_ID: '/aapi/gettemp_byid.php',
  GET_TEMPLATE_PRICE: '/aapi/gettemp_price.php',
  ONE_TIME_PAY: '/onetimepay/request.php',
  
  // Category endpoints
  GET_CATEGORIES: '/aapi/getcategories.php',
  SAVE_CATEGORY: '/aapi/savecategory.php',
  DELETE_CATEGORY: '/aapi/delete_category.php',
  TEMPLATES_BY_CATEGORY: '/aapi/tempbycat.php',
  
  // Developer API endpoints
  DEV_LOGIN: '/aapi/developer_api/login.php',
  DEV_REGISTER: '/aapi/developer_api/register.php',
  DEV_RESET_PASSWORD: '/aapi/developer_api/reset_password.php',
  DEV_GET_USER_DATA: '/aapi/developer_api/getuserdata.php',
  DEV_UPLOAD_TEMPLATE: '/aapi/developer_api/uploadtemplete.php',
  DEV_SAVE_TEMPLATE: '/aapi/developer_api/savetemplete.php',
  DEV_GET_USER_TEMPLATES: '/aapi/developer_api/gettempletesbyusers.php',
  
  // Package endpoints
  GET_PACKAGES: '/aapi/getPackages.php',
  GET_SUBSCRIPTION: '/aapi/getsubscription.php',
  
  // Other endpoints
  GET_TEMPLATES_BY_NAME: '/aapi/getTempletesbyName.php',
  GET_PAYMENTS: '/aapi/get_payments.php',
  GET_RECEIPT_TEMPLATES: '/aapi/get_recipttemps.php',
};

// Function to get the full URL for an endpoint
const getUrl = (endpoint, queryParams = {}) => {
  let url = `${API_URL}${endpoint}`;
  
  // Add query parameters if provided
  const queryString = new URLSearchParams(queryParams).toString();
  if (queryString) {
    url += `?${queryString}`;
  }
  
  return url;
};

// Generic fetch function with FormData support
const fetchAPI = async (endpoint, options = {}) => {
  const url = getUrl(endpoint);
  
  try {
    const response = await fetch(url, options);
    
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching ${url}:`, error);
    throw error;
  }
};

// Export the configuration
export default {
  ENV,
  API_URL,
  ENDPOINTS,
  getUrl,
  fetchAPI,
};
